import { connect } from 'react-redux';
import ReferralPrioritesForm from '../../../components/Admin/ReferralPriorities/ReferralPrioritesForm';
import { createReferralPriority, updateReferralPriority } from '../../../actions/entities/referralPriorities';
import { checkFeatureAccess } from '../../../utils/helpers';
import globals from '../../../globals/communityGlobals';

const mapStateToProps = ({ global: { auth } }) => {
  const access = auth.featureAccessList;
  return {
    access,
    canEditTreatments: checkFeatureAccess(auth.featureAccessList, globals.applicationFeatureAccesses.canEditTreatments),
  };
};

const mapDispatchToProps = dispatch => ({
  createReferralPriority: name => dispatch(createReferralPriority(name)),
  updateReferralPriority: referralPriorityId => dispatch(updateReferralPriority(referralPriorityId)),
});

const ReferralPrioritesFormPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReferralPrioritesForm);

export default ReferralPrioritesFormPage;
